module.exports = __webpack_public_path__ + "static/media/TFA Training-Spanish June 21 2012.120248c9.69617a5e.pdf";